import { SvelteComponent, init, safe_not_equal, element, attr, insert, listen, noop, detach } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import './EscButton.css.js';

/* src/ui/shared/components/EscButton/EscButton.svelte generated by Svelte v3.44.2 */

function create_fragment(ctx) {
	let span;
	let mounted;
	let dispose;

	return {
		c() {
			span = element("span");
			attr(span, "class", "esc-button wcl-1noefra");
		},
		m(target, anchor) {
			insert(target, span, anchor);

			if (!mounted) {
				dispose = listen(span, "click", /*click_handler*/ ctx[1]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { handleClick } = $$props;
	const click_handler = () => handleClick();

	$$self.$$set = $$props => {
		if ('handleClick' in $$props) $$invalidate(0, handleClick = $$props.handleClick);
	};

	return [handleClick, click_handler];
}

class EscButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { handleClick: 0 });
	}
}

export { EscButton as default };
//# sourceMappingURL=EscButton.svelte.js.map
